import { useState, useEffect } from "react";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import FloatingChatButton from "../components/FloatingChatButton";
import ChatWidget from "../components/Chat";
import { Outlet } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

export default function MainLayout({ headerText }) {
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [chatData, setChatData] = useState(null);

  // Access the user and helper methods directly
  const { user, authFetch } = useAuth();

  // EFFECT: Fetch chat data
  // Logic: If chat is closed, data is missing, and user exists -> Pre-fetch data
  useEffect(() => {

    const fetchChatData = async () => {
      // Safety check to ensure user exists before fetching
      if (!user?.id) return;

      console.log("Fetching chat data...");

      const messagesEndpoint = `${process.env.REACT_APP_API_URL}/api/chat/users/${user.id}/chats/latest`;

      console.log("messagesEndpoint: ", messagesEndpoint);

      try {
        const response = await authFetch(messagesEndpoint);
        const data = await response.json();

        console.log("Chat data fetched: ", data);

        if (data) {
          setChatData(data);
        }
      } catch (err) {
        console.error("Error fetching chat:", err);
      }
    };

    // Only run if chat is NOT open and we don't have data yet
    if (!chatData) {
      fetchChatData();
    }

    // Dependencies: Run this effect when these values change
  }, [chatData, user, authFetch]);

  const handleChatToggle = () => {
    setIsChatOpen((prev) => !prev);
    console.log("Chat toggled. New state:", !isChatOpen);
  };

  return (
    <div className="h-screen overflow-hidden bg-[#EDF0F2] font-sans text-[#323334] flex pt-[64px]">
      {/* Sidebar fijo */}
      <Sidebar />

      {/* Contenido principal */}
      <div className="flex-1 ml-0 lg:ml-[302px] p-4 sm:p-6 h-[calc(100vh-64px)] overflow-y-auto">
        <div className="rounded-2xl border border-white/45 bg-white/35 backdrop-blur-md shadow-[0_12px_30px_rgba(15,23,42,0.10)] px-3 sm:px-5 py-2 sm:py-3 mb-5">
          <div className="flex items-center justify-between gap-3 sm:gap-4">
            <div className="min-w-0 pl-1">
              <h2 className="text-lg sm:text-2xl font-bold text-slate-900 truncate">{headerText}</h2>
            </div>

            <Header />
          </div>
        </div>

        <Outlet context={{ chatData }} />
      </div>

      {/* Botón flotante */}
      {/* <FloatingChatButton onClick={handleChatToggle} /> */}

      {/* Chat flotante funcional */}

    </div>
  );
}